export default [
	{ label: "Сумма", labelShort: "Сумма", value: 1 },
	{ label: "Процент", labelShort: "%", value: 2 },
]
